import { ShopifyCart } from '../models/ShopifyCart.model';
import { ProductCategory } from '../enums/ProductCategory.enum';

export const cartHasGarments = (cart?: ShopifyCart): boolean => cartGarmentCount(cart) > 0;

export const cartGarmentCount = (cart?: ShopifyCart): number => {
  const excludedProductTypes = [ProductCategory.AddOns, ProductCategory.GiftCard];
  const nonExcludedCartItems = cart?.lineItems?.filter(({ product_type }) => !excludedProductTypes.includes(product_type as ProductCategory)) ?? [];
  return nonExcludedCartItems.reduce((acc, { quantity }) => quantity + acc, 0);
};
